import LoginForm from "../../components/LoginForm/LoginForm";
import PageStyle from "../../components/PageStyle";

const UserLoginPage = () => {
  return (
    <PageStyle>
      <LoginForm />
    </PageStyle>
  );
};
export default UserLoginPage;
